import PopoverModel, { PopoverMenuProps } from '../PopoverModel/PopoverModel';
import useToggleDropdown from '../DropdownMenu/useToggleDropdown';
import Surface from "@able/react/dist/Surface";
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import CheckboxGroup from '../CheckboxGroup/CheckboxGroup';
import Divider from '@able/react/dist/Divider';
import FilterByString, { FilterByStringProps } from '../FilterByString/FilterByString';
import ActionButton from '@able/react/dist/ActionButton';
import '../PopoverModel/style.scss';
import Checkbox from '../Checkbox';

interface searchFilterType { searchFilter?: boolean }

export interface PopoverMultiSelectEvents {
    onApply: (value: any) => void;
    onCancel: () => void;
}

export type PopoverMultiSelectProps = PopoverMenuProps & searchFilterType & PopoverMultiSelectEvents

const PopoverMultiselect = (props: PopoverMultiSelectProps) => {
    const { multiSelectValues, developmentUrl, searchFilter } = props;
    const [searchText, setSearchText] = useState<string>("");
    const [checkedValues, setCheckedValues] = useState<string[]>([]);
    const [selectedValues, setSelectedValues] = useState<any>(multiSelectValues);
    const [appliedValues, setAppliedValues] = useState<string[]>([]);
    const isFirstRender = useRef(true);
    const getQueryText = (value: string) => {
        setSearchText(value);
        value.length === 0 && setSelectedValues(multiSelectValues);
    };

    const [isExpand, setExpand] = useToggleDropdown();
    const ref = useRef<HTMLButtonElement>(null);
    const filterByStringRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setExpand(props.isExpanded);
    }, [props.isExpanded])

    const filterbyStringArgs: FilterByStringProps = {
        id: "search",
        developmentUrl: developmentUrl,
        placeholderText: 'Search',
        variant: "default",
        hasSearchButton: false,
        customSearchLength: 1,
        ariaDescribedBy: "default",
        getQueryText: getQueryText,
        value: "",
        elementRef: filterByStringRef
    };

    useEffect(() => {
        if (searchText.length >= 1 && isExpand) {
            const filterVal = multiSelectValues && multiSelectValues.filter((selectedVal: { label: string; value: string; }) => (selectedVal && (selectedVal.label.toLowerCase().includes(searchText) || selectedVal.label.includes(searchText) || selectedVal.value.toLowerCase().includes(searchText) || selectedVal.value.includes(searchText))));
            setSelectedValues(filterVal);
        } else {
            setSelectedValues(multiSelectValues);
            setSearchText("");
        }
    }, [searchText, isExpand]);

    useEffect(() => {
        const defaultChecked: string[] = [];
        multiSelectValues && multiSelectValues.map((selectedVal) => {
            if (selectedVal.checked) {
                defaultChecked.push(selectedVal.id)
            }
        });
        setCheckedValues(defaultChecked);
        setAppliedValues(defaultChecked);
    }, [multiSelectValues]);

    //Use Effect to Handle click Outside 
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!isExpand) {
            clearVal();
        }
    }, [isExpand]);

    const onChange = (e: ChangeEvent<HTMLInputElement>, id: string) => {
        const arr: string[] = [...checkedValues];
        if (e.target.checked) {
            arr.push(id);
        } else {
            const index = arr.indexOf(id);
            arr.splice(index, 1);
        }
        setCheckedValues(arr);
    };

    const clearVal = () => {
        setCheckedValues(appliedValues);
        setSelectedValues(multiSelectValues);
        setSearchText("");
        setExpand(false);
    }

    const cancel = () => {
        props.onCancel && props.onCancel();
        clearVal();
        (ref.current as HTMLButtonElement).focus();
    }

    const apply = () => {
        const appliedData = multiSelectValues?.filter((multiSelectValue) => checkedValues.includes(multiSelectValue.id))
        props.onApply && props.onApply(appliedData);
        setAppliedValues(checkedValues);
        setExpand(false);
        (ref.current as HTMLButtonElement).focus();
    }

    const applyKeyUp = (e: KeyboardEvent) => {
        e.preventDefault();
        if (e.key === "Tab") {
            searchFilter ? (filterByStringRef.current as HTMLInputElement).focus() : (ref.current as HTMLButtonElement).focus();
        }
        if (e.key === "Enter") {
            apply();
        }
    }

    return (
        <PopoverModel {...props} isExpanded={isExpand} setExpanded={setExpand} buttonRef={ref}>
            <Surface
                className={`popoverContent`}
                interactive={false}
                variant="SurfaceFlat"
            >
                <div className="multiselect">
                    {searchFilter && <><div className="spacing-compact">
                        <FilterByString
                            {...filterbyStringArgs}
                        />
                    </div></>}
                    {<div className="result" role="status">
                        <span>{`Showing`} <strong>{`${selectedValues.length} `}</strong> </span> {searchFilter ? "of" : ""}
                        {searchFilter ? <strong>{` ${multiSelectValues && multiSelectValues.length}`}</strong> : "items"}
                        {`. `}<strong>{`${checkedValues.length} `}</strong>{`selected.`}
                    </div>}
                    <Divider />
                    <CheckboxGroup developmentUrl={developmentUrl} errorText="error text" groupLabel="" helpText="" required variant="Compact" ariaLabel="CheckboxGroup" className="multiselect-popover">
                        <> {selectedValues && selectedValues.map((selectedValue: any, i: number) => {
                            return <Checkbox
                                key={selectedValue.label + i}
                                developmentUrl={developmentUrl}
                                id={selectedValue.id}
                                label={selectedValue.label}
                                name={selectedValue.name}
                                disabled={selectedValue.disabled}
                                onChange={(e) => onChange(e, selectedValue.id)}
                                value={selectedValue.value}
                                variant="Compact"
                                checked={checkedValues.includes(selectedValue.id)} />
                        }
                        )}  </>
                    </CheckboxGroup>
                    <Divider />
                    <div className="spacing-compact button-content">
                        <ActionButton label='Cancel' element={'button'} variant={'MediumEmphasisCompact'} data-testid={"cancelbtn"}
                            events={{
                                onClick: cancel
                            }}
                        />
                        <ActionButton label='Apply' element={'button'} variant={'HighEmphasisCompact'} data-testid={"applybtn"}
                            events={{
                                onClick: apply,
                                onKeyDown: (e: KeyboardEvent) => applyKeyUp(e)

                            }}
                        />
                    </div>

                </div>
            </Surface>
        </PopoverModel>
    );
};

export default PopoverMultiselect;